import { render, staticRenderFns } from "./DesignEV.vue?vue&type=template&id=5761180d&scoped=true"
import script from "./DesignEV.vue?vue&type=script&lang=js"
export * from "./DesignEV.vue?vue&type=script&lang=js"
import style0 from "./DesignEV.vue?vue&type=style&index=0&id=5761180d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5761180d",
  null
  
)

export default component.exports